import { Component, OnInit, ɵConsole } from '@angular/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { UserService } from '../../services/user.service';
import { Actualizacion } from '../../models/actualizacion';
import Swal from 'sweetalert2';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DireccionesComponent } from 'src/app/direcciones/direcciones.component';
import { formatDate, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatFileUploadModule } from 'angular-material-fileupload';

import { MomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as _moment from 'moment';
import { MessageService } from 'primeng/api';
import { ciudades } from 'src/app/models/ciudades';

//import { environment } from 'src/environments/environment';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

registerLocaleData(localeEs, 'es');

@Component({
  selector: 'app-actualizacion',
  templateUrl: './actualizacion.component.html',
  styleUrls: ['./actualizacion.component.css'],
  providers: [UserService,
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})

export class ActualizacionComponent implements OnInit {

  public prod = environment.production

  public formularioActualizacion;
  public ipAddress;

  private oficinas: any
  //grupos
  public grupoAsociados;
  public grupoAsociados2;
  public grupoLaboral;
  public grupoFinanciera;
  public grupoFamiliar;
  public grupoFamiliarInfo;
  public grupoReferenciaFam;
  public grupoReferenciaPer;
  public grupoReferencia;
  public verdadero = false;
  public Loading = false;
  public isCompleted = true;
  public autorizacion;
  public familiares = [];

  public grupos = new Array();
  public camposSeparadosS;
  public camposSeparadosN;
  public identity;
  public select = new Array();
  public check = new Array();
  //Variables para el change
  public campoFiltrada;
  public CiudadNombreFiltrada = new Array();
  public ciudadesFiltrada = new Array();
  public valor = new Array();
  public SiNo;
  public NombreSiNo = new Array();
  ////////////////////////////////////////
  public Actualizacion: any;
  public campo;
  public direccion;
  public fecexp;
  public fecnac;
  public fechaingempresa;
  public maxDateNac;
  public currentYear;
  actual = environment.actual;
  public columnasactualizacion
  public colorInfoClau
  public activaClausula
  public textClausula
  public actualizacionConfig
  public respuestaImg;
  public urlImg = environment.entidad[this.actual].urlEndPoint
  public mobile
  public width
  public remove
  private entidad
  /*CAMBIAR A TRUE PORQUE SE DEJO INACTIVO SOLO PORQUE LA ENTIDAD ES */
  private validPorcentaje = true
  public attrFam = {
    disabled: {
      familiar1: {
        NITRESPONSABLE: 'true',
        CELULARRESPONSABLE: 'true',
        CODPARENTESCO: 'false',
        APELLIDOS: 'false',
        TIPONIT: 'false',
        PORCENTAJE: 'false',
        CODNIVELESCOLARIDAD: 'false',
        NIT: 'false',
        NOMBRES: 'false',
        FHANACIMIENTO: 'false',
        APELLIDOSRESPONSABLE: 'true',
        NOMBRESRESPONSABLE: 'true'
      }
    }
  }

  constructor(
    private _userService: UserService,
    private router: Router,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private messageService: MessageService
  ) {
    this.currentYear = formatDate(new Date(), 'yyyy-MM-dd', 'es');
    this.maxDateNac = formatDate('2003-01-01', 'yyyy-MM-dd', 'es');
    console.log('prod:', this.prod)
  }

  ngOnInit() {
    this.actualizacionConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    if (window.screen.width > 768) {
      this.mobile = true;
      this.width = this.actualizacionConfig.actualizacion.columnasactualizacion;
    } else {
      console.log(window.screen.width)
      this.mobile = false;
      this.width = '12'
    }
    this.colorInfoClau = this.actualizacionConfig.actualizacion.colorInfoClau
    this.activaClausula = this.actualizacionConfig.actualizacion.activClauActualiza
    this.textClausula = this.actualizacionConfig.actualizacion.textClausula
    this.entidad = environment.entidad[this.actual].entidadNombre
    this.spinner.show()
    this.Actualizacion = new Actualizacion();
    this.campoFiltrada = new ciudades();
    this.Actualizacion.familiares = {}
    this.FormularioActualizacionDatos();
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.CargarAutorizacion();
    //
    if (this.actualizacionConfig.actualizacion.actDeclaracion == 'S') {
      this.messageService.add({ severity: 'info', detail: 'this.actualizacionConfig.actualizacion.textDeclaracion' });
    } else {
      this.verificaActualizacion();
    }
  }

  FormularioActualizacionDatos() {
    this._userService.httpGet('getParamsActualizacion').subscribe(response => {
      if (response.status == 'success') {

        this.formularioActualizacion = response.details;

        this.grupoAsociados = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'BASICOS');
        this.grupoAsociados2 = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'BASICOS2');
        this.grupoLaboral = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'LABORAL');
        this.grupoFinanciera = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'FINANCIERA');
        this.grupoFamiliar = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'FAMILIAR');
        this.grupoFamiliarInfo = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'INFORMACION FAMILIAR');
        this.grupoReferenciaFam = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'REFERENCIAS FAMILIARES');
        this.grupoReferenciaPer = this.formularioActualizacion.filter(item => item.NOMBREGRUPOCAMPO == 'REFERENCIAS PERSONALES');
        if (typeof this.grupoAsociados !== 'undefined' && this.grupoAsociados.length > 0) {
          this.grupos.push(this.grupoAsociados);
        }
        if (typeof this.grupoAsociados2 !== 'undefined' && this.grupoAsociados2.length > 0) {
          this.grupos.push(this.grupoAsociados2);
        }
        if (typeof this.grupoLaboral !== 'undefined' && this.grupoLaboral.length > 0) {
          this.grupos.push(this.grupoLaboral);
        }
        if (typeof this.grupoFinanciera !== 'undefined' && this.grupoFinanciera.length > 0) {
          this.grupos.push(this.grupoFinanciera);
        }

        if (typeof this.grupoReferenciaFam !== 'undefined' && this.grupoReferenciaFam.length > 0) {
          this.grupos.push(this.grupoReferenciaFam);
        }
        if (typeof this.grupoReferenciaPer !== 'undefined' && this.grupoReferenciaPer.length > 0) {
          this.grupos.push(this.grupoReferenciaPer);
        }
        if (typeof this.grupoFamiliar !== 'undefined' && this.grupoFamiliar.length > 0) {
          this.grupos.push(this.grupoFamiliar);
        }
        if (typeof this.grupoFamiliarInfo !== 'undefined' && this.grupoFamiliarInfo.length > 0) {
          this.grupos.push(this.grupoFamiliarInfo);
        }

        this.formularioActualizacion.forEach(element => {
          if (element.TIPOINPUTCAMPO === 'select' || element.TIPOINPUTCAMPO === 'option') {
            this.SelectDinamico(element.TABLAOPTION, element.ITEM1, element.ITEM2, element.ITEM3, element.NOMBRECAMPO);

          } else if (element.TIPOINPUTCAMPO === 'check') {
            this.Check(element.NOMBRECAMPO, element.TABLAOPTION, element.ITEM1, element.ITEM2)
          }
          if (this.actual == 'colaborar' || this.actual == 'fesfa' || this.actual == 'fonfedepalma') {
            if (element.NOMBREGRUPOCAMPO == 'FAMILIAR') {
              element.NOMBREGRUPOCAMPO = 'BENEFICIARIOS'
            }
          } else if (this.actual == 'fesol') {
            if (element.NOMBREGRUPOCAMPO == 'FAMILIAR') {
              element.NOMBREGRUPOCAMPO = 'HIJOS'
            }
          }
        });
        this.PrecargaDatos(this.identity.USUARIO);
      } else {
        console.log(response);
        this.spinner.hide()
        this.messageService.add({ severity: 'error', summary: 'Hubo un error', detail: 'Hubo un problema al cargar el formulario, por favor intentelo de nuevo mas tarde' });
      }
    },
      error => {
        console.log(<any>error);
        this.spinner.hide()
        this.messageService.add({ severity: 'error', summary: 'Hubo un error', detail: 'Hubo un problema con la conexión, por favor intentelo de nuevo mas tarde' });
      }
    );
  }


  CiudadesFiltro(campoS, valor, tipo, valid: string, campoN, fam) {
    this.camposSeparadosS = []
    this.camposSeparadosN = []
    if (campoS != null && campoS != undefined) {
      if (campoS.toString().indexOf(';') >= 0) {
        this.camposSeparadosS = campoS.split(';');
      } else {
        this.camposSeparadosS = campoS;
      }
    }

    if (campoN != null && campoN != undefined) {
      if (campoN.toString().indexOf(';') >= 0) {
        this.camposSeparadosN = campoN.split(';');
      } else {
        this.camposSeparadosN = campoN;
      }
    }

    if (tipo == 'FILTROSELECT') {

      valor = valor.toUpperCase();
      this.campoFiltrada[campoS] = this.select[campoS].filter(item => {
        return item.DESCRIPCION.toLowerCase().indexOf(
          valor.toLowerCase()) > -1;
      });

      /*this.ciudadFiltrada = this.select['CIUDAD'].filter(item => item.PARAMETRO == valor);
      this.ciudadesFiltrada[campoS] = this.ciudadFiltrada;
      this.CiudadNombreFiltrada[campoS] = campoS;*/

    } else if (tipo == 'DISABLEDCAMPO') {
      let value: string

      if (valor.value != undefined) {
        value = valor.value
      }
      else {
        value = valor;
      }
      if (valid.includes(value)) {
        if (this.camposSeparadosS) {
          this.camposSeparadosS.forEach(camposSeparadosVS => {
            this.grupos.forEach(grupo => {
              grupo.forEach(element => {
                if (element.NOMBRECAMPO == camposSeparadosVS) {
                  element.DISABLEDCAMPO = 'false';
                }
              });
            });
          });
        }

        if (this.camposSeparadosN) {
          this.camposSeparadosN.forEach(camposSeparadosVN => {
            this.grupos.forEach(grupo => {
              grupo.forEach(element => {
                if (element.NOMBRECAMPO == camposSeparadosVN) {
                  element.DISABLEDCAMPO = 'true';
                  if (this.Actualizacion[camposSeparadosVN] != null && this.Actualizacion[camposSeparadosVN] != undefined) {
                    this.Actualizacion[camposSeparadosVN] = ""
                  }
                }
              });
            });
          });
        }
      } else {
        if (this.camposSeparadosS) {
          this.camposSeparadosS.forEach(camposSeparadosVS => {
            this.grupos.forEach(grupo => {
              grupo.forEach(element => {
                if (element.NOMBRECAMPO == camposSeparadosVS) {
                  element.DISABLEDCAMPO = 'true';
                  if (this.Actualizacion[camposSeparadosVS] != null && this.Actualizacion[camposSeparadosVS] != undefined) {
                    this.Actualizacion[camposSeparadosVS] = ""
                  }
                }
              });
            });
          });
        }
        if (this.camposSeparadosN) {
          this.camposSeparadosN.forEach(camposSeparadosVN => {
            this.grupos.forEach(grupo => {
              grupo.forEach(element => {
                if (element.NOMBRECAMPO == camposSeparadosVN) {
                  element.DISABLEDCAMPO = 'false';
                }
              });
            });
          });
        }
      }
    }
    else if (tipo == 'PARENTFAMDOCREQUIRED') {
      let validar
      if (valid.toString().indexOf(';') >= 0) {
        validar = valid.split(';');
      } else {
        validar = valid;
      }
      console.log(validar)
      console.log(this.Actualizacion.familiares)
      var campo = document.getElementById('fileFam' + fam);
      if (validar.includes(valor.toString())) {
        this.Actualizacion.familiares['familiar' + fam].REQUIRED = 'REQUIRED'
        console.log('entro')
      } else {
        this.Actualizacion.familiares['familiar' + fam].REQUIRED = null
        console.log('no entro')
      }
      var campo = document.getElementById('fileFam' + fam);
      console.log(campo)
    }
    else if (tipo == 'FAMMENOR') {
      let fhaNac = new Date(this.Actualizacion.familiares['familiar' + fam].FHANACIMIENTO)
      let fhaact = new Date()

      let data = {
        fechaNac: fhaNac,
        fechaAct: fhaact
      }

      this._userService.httpPost('edadAgno', data).subscribe(
        (resp: any) => {
          if (resp.details.EDAD < 18) {
            console.log('es menor')
            if (this.camposSeparadosS) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                this.attrFam.disabled['familiar' + fam][camposSeparadosVS] = 'false'
              });
            }
          } else {
            console.log('es mayor')
            if (this.camposSeparadosS) {
              this.camposSeparadosS.forEach(camposSeparadosVS => {
                this.attrFam.disabled['familiar' + fam][camposSeparadosVS] = 'true'
              });
            }
          }
        },
        error => {
          console.log(error)
        }
      )
    }
    else if (tipo == 'VALIDPORCENTAJE') {
      console.log('VALIDPORCENTAJE: ', valor)
      if (valor != '') {
        this.Actualizacion.familiares['familiar' + fam].PORCENTAJE = parseInt(valor)
      } else {
        this.Actualizacion.familiares['familiar' + fam].PORCENTAJE = 0
      }
      let porcent = 0;
      Object.keys(this.Actualizacion.familiares).forEach(resp => {
        porcent = porcent + this.Actualizacion.familiares[resp].PORCENTAJE
      })

      this.messageService.clear();

      if (porcent == 100) {
        this.validPorcentaje = true
      }/* else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'La suma de los porcentajes tiene que dar como resultado el 100%' });
        this.validPorcentaje = false
      }*/
    }
    else if (tipo == 'VERIFICACORREO') {
      let email1 = ""
      Swal.fire({
        title: 'Ingrese su correo',
        input: 'email',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          console.log(login)
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result: any) => {
        if (result.isConfirmed) {
          email1 = result.value
          Swal.fire({
            title: 'Confirme su correo',
            input: 'email',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              console.log(login)
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then((result2: any) => {
            if (result2.isConfirmed) {
              if (email1 === result2.value) {
                this.Actualizacion.email1 = email1
              } else {
                Swal.fire({
                  icon: "error",
                  text: "El correo no coincide"
                })
              }
            }
          })
        }
      })
    } else if (tipo == 'OFIFONASBCOL') {
      console.log(this.select['codofi'])
      console.log(valor)

      this.select['codofi'] = this.oficinas.filter(item => {
        return item.CODENT == valor
      });
    }
  }


  SelectDinamico($tabla, $item1, $item2, $item3, $campo) {
    //this._userService.SelectDinamico($tabla, $item1, $item2, $item3).subscribe(
    this.Actualizacion['tabla'] = $tabla
    this.Actualizacion['item1'] = $item1
    this.Actualizacion['item2'] = $item2
    this.Actualizacion['item3'] = $item3

    //console.log(this.Actualizacion)
    this._userService.httpPost('selectDinamico', this.Actualizacion).subscribe(
      response => {
        //this.select[$campo] = response;
        if ($tabla == 'OFICINAS') {
          this.oficinas = response
        } else {
          this.select[$campo] = response;
        }
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
        this.messageService.add({ severity: 'error', summary: 'Hubo un error', detail: 'Hubo un problema al cargar el formulario, por favor intentelo de nuevo mas tarde' });
      }
    );
  }

  Check(campo, tabla, item1, item2) {
    this.Actualizacion['tabla'] = tabla
    this.Actualizacion['item1'] = item1
    this.Actualizacion['item2'] = item2
    this._userService.httpPost('check', this.Actualizacion).subscribe(
      response => {
        this.check[campo] = response
      }
    )
  }


  insertarDireccion(nombreCampo, fam) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    const modalRef = this.dialog.open(DireccionesComponent, {
      autoFocus: false,
      maxHeight: '80vh' //you can adjust the value as per your view
    });
    modalRef.afterClosed().subscribe(res => {
      console.log(res)

      if (res.dir != null && res.dir != undefined && res.dir != 'undefined' && res.dir != false) {

        if (fam == 0) {
          this.grupos.forEach(grupo => {
            grupo.forEach(element => {
              if (element.NOMBRECAMPO == nombreCampo) {
                this.Actualizacion[element.NOMBRECAMPO] = res.dir;
              }
            });
          });
        } else {
          this.Actualizacion.familiares['familiar' + fam][nombreCampo] = res.dir;
        }
      }
    })
  }


  PrecargaDatos($usuario) {
    this.Actualizacion = new Actualizacion()
    this.Actualizacion.usuario = $usuario
    this.Actualizacion.cod = this.identity.CODASOCIADO
    this._userService.httpPost('precargaDatos', this.Actualizacion).subscribe(
      (response: any) => {
        this.spinner.hide()
        this.Actualizacion = response;
        function sumarDias(fecha, dias) {
          fecha.setDate(fecha.getDate() + dias);
          return fecha;
        }
        var d;
        var n;
        var i;
        if (response.fechaexp) {
          d = response.fechaexp
          if (d.toString().indexOf(' ')) {
            let valor = d.split(' ');
            d = valor[0];
          }
          if (d.toString().indexOf('T')) {
            let valor = d.split('T');
            d = valor[0];
          }

          d = new Date(d + ' 11:00')

          this.fecexp = d.toISOString();
        }
        if (response.fechanac) {
          n = response.fechanac
          if (n.toString().indexOf(' ')) {
            let valor = n.split(' ');
            n = valor[0];
          }
          if (n.toString().indexOf('T')) {
            let valor = n.split('T');
            n = valor[0];
          }
          n = new Date(n + ' 11:00')
          this.fecnac = n.toISOString();
        }
        if (response.fechaingempresa) {
          i = response.fechaingempresa

          if (i.toString().indexOf(' ')) {
            let valor = i.split(' ');
            i = valor[0];
          }

          if (i.toString().indexOf('T')) {
            let valor = i.split('T');
            i = valor[0];
          }

          console.log(i)
          i = new Date(i + ' 11:00')

          this.fechaingempresa = i.toISOString();
        }

        if (response.declararenta) {
          if (response.declararenta == 1) {
            this.Actualizacion.declararenta = 'S'
          } else {
            this.Actualizacion.declararenta = 'N'
          }
        }

        /*
        this.fecexp = formatDate(new Date(sumarDias(d, + 1)), 'yyyy-MM-dd', 'es');
        this.fecnac = formatDate(new Date(sumarDias(n, + 1)), 'yyyy-MM-dd', 'es');
        this.fechaingempresa = formatDate(new Date(sumarDias(i, + 1)), 'yyyy-MM-dd', 'es');*/
        if (typeof this.grupoFamiliar !== 'undefined' && this.grupoFamiliar.length > 0) {
          if (!response.familiares) {
            if (this.actualizacionConfig.actualizacion.actPrFam == 'S') {
              this.attrFam.disabled['familiar1'] = {
                NITRESPONSABLE: 'true',
                CELULARRESPONSABLE: 'true',
                CODPARENTESCO: 'false',
                APELLIDOS: 'false',
                TIPONIT: 'false',
                PORCENTAJE: 'false',
                CODNIVELESCOLARIDAD: 'false',
                NIT: 'false',
                NOMBRES: 'false',
                FHANACIMIENTO: 'false',
                APELLIDOSRESPONSABLE: 'true',
                NOMBRESRESPONSABLE: 'true'
              }
              this.familiares.push(1)
              this.Actualizacion.familiares = { familiar1: { REQUIRED: null } }
              this.remove = false;
            }
          } else {
            let matriz = Object.values(response.familiares)
            for (let f = 1; f <= matriz.length; f++) {
              this.CiudadesFiltro('', this.Actualizacion.familiares['familiar' + f].PORCENTAJE, 'VALIDPORCENTAJE', '', '', f)
              this.Actualizacion.familiares['familiar' + f].REQUIRED = null
              this.attrFam.disabled['familiar' + f] = {
                NITRESPONSABLE: 'true',
                CELULARRESPONSABLE: 'true',
                CODPARENTESCO: 'false',
                APELLIDOS: 'false',
                TIPONIT: 'false',
                PORCENTAJE: 'false',
                CODNIVELESCOLARIDAD: 'false',
                NIT: 'false',
                NOMBRES: 'false',
                FHANACIMIENTO: 'false',
                APELLIDOSRESPONSABLE: 'true',
                NOMBRESRESPONSABLE: 'true'
              }
              if (this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO) {
                if (this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO.toString().indexOf('T')) {
                  let valor = this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO.split('T');
                  console.log(valor[0])
                  this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO = new Date(valor[0] + ' 11:00').toISOString();
                } else if (this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO.toString().indexOf(' ')) {
                  let valor = this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO.split(' ');
                  console.log(valor[0])
                  this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO = new Date(valor[0] + ' 11:00').toISOString();
                } else {
                  this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO = new Date(this.Actualizacion.familiares['familiar' + f].FHANACIMIENTO + ' 11:00').toISOString();
                }
              }
              this.familiares.push(f)
              console.log(this.attrFam)
            }

            if (this.actualizacionConfig.actualizacion.actPrFam == 'S') {
              if (this.familiares.length == 1) {
                this.remove = false;
              } else if (this.familiares.length > 1) {
                this.remove = true;
              }

            }
          }
        }

        if (this.actual == 'fesol') {
          this.Actualizacion.email1 = ''
        }

        if (this.actual == 'fonasbcol') {
          this.Actualizacion.empresa = ''
          this.Actualizacion.codofi = ''
        }

        console.log(this.Actualizacion)
        /*this.Actualizacion.FECHANAC= new Date(this.Actualizacion.FECHANAC);
        this.Actualizacion.FECHAEXP= new Date(this.Actualizacion.FECHAEXP);
        this.Actualizacion.FECHAINGRESO= new Date(this.Actualizacion.FECHAINGRESO);*/
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    );

  }

  CargarAutorizacion() {
    let data = {
      autorizacion: "WEB_AUTORIZACION_ACTUALIZACION"
    }
    this._userService.httpPost('cargaEntidad', data).subscribe(
      response => {
        this.autorizacion = response['WEBAUTORIZACION'];
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  guardar(forma: any, envio: boolean) {
    if (forma.valid) {
      this.isCompleted = true;
      if (envio) {
        this.verdadero = true;
      }
    } else {
      this.isCompleted = false;
    }

    if (this.verdadero) {
      if (this.Actualizacion.Acepto == 'S') {
        this.spinner.show()
        console.log(this.Actualizacion)
        if (this.Actualizacion.familiares) {
          if (this.Actualizacion.familiares.length > 0) {
            for (let i = 0; i < this.Actualizacion.familiares.length; i++) {
              delete this.Actualizacion.familiares['familiar' + i].REQUIRED
            }
          }
        }
        if (this.validPorcentaje) {
          if (this.grupos.length > 0) {
            this._userService.getIPAddress().subscribe((res: any) => {
              this.ipAddress = res.ip;
              this.Actualizacion.CodAsociado = this.identity.CODASOCIADO;
              this.Actualizacion.Ip = this.ipAddress;
              this._userService.httpPost('guardaActualizacion', this.Actualizacion).subscribe(response => {
                if (response.status == 'success') {
                  this.messageService.clear();
                  this.messageService.add({ key: 'c', sticky: true, severity: 'success', summary: 'Proceso Exitoso!', detail: 'Los cambios se han enviado al administrador pendientes por ser aprobados' });
                } else {
                  this.messageService.add({ severity: 'error', summary: 'Hubo un error!' });
                }
                this.spinner.hide()
              },
                error => {
                  this.messageService.clear();
                  this.messageService.add({ key: 'c', sticky: true, severity: 'error', summary: 'Error al actualizar', detail: 'Comuniquese con el administrador' });
                  console.log(<any>error);
                  this.spinner.hide()
                }
              );
            },
              error => {
                console.log(error)
                this.spinner.hide()
              });
          } else {
            this.spinner.hide()
            this.messageService.add({ severity: 'error', summary: 'Error al actualizar', detail: 'No se pudo cargar el formulaario por lo tando no se puede enviar la actualización de datos' });
          }
        } else {
          this.spinner.hide()
          let nameFam = ''
          if (this.actual == 'colaborar') {
            nameFam = "beneficiarios"
          } else {
            nameFam = "familiares"
          }
          this.messageService.add({ severity: 'error', summary: 'Error al actualizar', detail: 'Por favor revise los porcentajes de los ' + nameFam + ', estos deben dar el 100%' });
        }
      }
    }
  }


  verificaActualizacion() {
    console.log(this.identity.USUARIO)
    const datos: any = { datos: this.identity.USUARIO };
    this._userService.httpPost('enproceso', datos).subscribe(
      response => {
        if (response['procesado'] == 'N') {
          this.messageService.add({ severity: 'warn', summary: 'Actualización en proceso', detail: 'Si continúa con el proceso invalidará la actualización anterior', life: 50000 });
        }
      },
      error => {
        console.log(<any>error);
      }
    );

  }

  agregarFamiliar() {
    let num = this.familiares.length
    if (num > 0) {
      num = num + 1
      this.Actualizacion.familiares['familiar' + num] = { REQUIRED: 'REQUIRED' }
      this.familiares.push(num)
    } else {
      num = num + 1
      this.Actualizacion.familiares = {}
      this.Actualizacion.familiares['familiar' + num] = { REQUIRED: 'REQUIRED' }
      this.familiares.push(num)
    }
    this.attrFam.disabled['familiar' + num] = {
      NITRESPONSABLE: 'true',
      CELULARRESPONSABLE: 'true',
      CODPARENTESCO: 'false',
      APELLIDOS: 'false',
      TIPONIT: 'false',
      PORCENTAJE: 'false',
      CODNIVELESCOLARIDAD: 'false',
      NIT: 'false',
      NOMBRES: 'false',
      FHANACIMIENTO: 'false',
      APELLIDOSRESPONSABLE: 'true',
      NOMBRESRESPONSABLE: 'true'
    }
    if (this.actualizacionConfig.actualizacion.actPrFam == 'S') {
      if (this.familiares.length > 1) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    } else {
      this.remove = true;
    }
  }

  removerFamiliar(op) {
    this.familiares.pop()
    let cont = Object.getOwnPropertyNames(this.Actualizacion.familiares)
    delete this.Actualizacion.familiares['familiar' + cont.length]
    if (this.actualizacionConfig.actualizacion.actPrFam == 'S') {
      if (this.familiares.length >= 2) {
        this.remove = true;
      } else {
        this.remove = false;
      }
    }
  }

  subida(event, familiar) {
    if (event.event.body) {
      if (event.event.body.status == 'success') {
        console.log(event.event.body)
        console.log(familiar)
        this.Actualizacion.familiares['familiar' + familiar].doc = event.event.body.filename
        this.messageService.add({ severity: 'success', detail: event.event.body.message });
      } else {
        this.messageService.add({ severity: 'error', detail: event.event.body.message });
      }
    }
  }

  onConfirm() {
    this.router.navigate(['/home']);
  }

}

